import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import moment from 'moment';

const DateRangePicker = ({ 
    value, 
    onChange, 
    minDate, 
    maxDate, 
    size = "small",
    sx = {},
    startLabel = "Date de début",
    endLabel = "Date de fin"
}) => {
    const [startDate, endDate] = value || [null, null];

    const handleStartDateChange = (event) => {
        const newStartDate = event.target.value ? moment(event.target.value) : null;
        onChange([newStartDate, endDate]);
    };

    const handleEndDateChange = (event) => {
        const newEndDate = event.target.value ? moment(event.target.value) : null;
        onChange([startDate, newEndDate]);
    };

    const getStartDateProps = () => {
        const props = {
            min: minDate ? moment(minDate).format('YYYY-MM-DD') : undefined,
            max: maxDate ? moment(maxDate).format('YYYY-MM-DD') : undefined
        };
        
        // Si une date de fin est sélectionnée, la date de début ne peut pas être postérieure
        if (endDate) {
            props.max = moment.min(moment(endDate), moment(maxDate || new Date())).format('YYYY-MM-DD');
        }
        
        return props;
    };

    const getEndDateProps = () => {
        const props = {
            min: minDate ? moment(minDate).format('YYYY-MM-DD') : undefined,
            max: maxDate ? moment(maxDate).format('YYYY-MM-DD') : undefined
        };
        
        // Si une date de début est sélectionnée, la date de fin ne peut pas être antérieure
        if (startDate) {
            props.min = moment.max(moment(startDate), moment(minDate || '1900-01-01')).format('YYYY-MM-DD');
        }
        
        return props;
    };

    return (
        <Stack direction="row" spacing={2} sx={sx}>
            <TextField
                size={size}
                label={startLabel}
                type="date"
                value={startDate ? startDate.format('YYYY-MM-DD') : ''}
                onChange={handleStartDateChange}
                InputLabelProps={{ shrink: true }}
                inputProps={getStartDateProps()}
                sx={{ minWidth: '140px' }}
            />
            <Typography sx={{ alignSelf: 'center', color: 'text.secondary' }}>
                à
            </Typography>
            <TextField
                size={size}
                label={endLabel}
                type="date"
                value={endDate ? endDate.format('YYYY-MM-DD') : ''}
                onChange={handleEndDateChange}
                InputLabelProps={{ shrink: true }}
                inputProps={getEndDateProps()}
                sx={{ minWidth: '140px' }}
            />
        </Stack>
    );
};

export default DateRangePicker;